import {
  ROBLOX_TOP_CHARTS_DOWNLOAD_COLUMN_META,
  ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/conf/robloxTopChartsDownloadMeta';
import { ROBLOX_TOP_CHARTS_METRIC_VALUES } from './robloxTopChartsMetrics';
import type { IRobloxTopChartsDownloadGameInfo } from '../components/RobloxTopChartsDownload/types';

export interface IRobloxTopChartsDownloadGameInfoOption {
  key: keyof IRobloxTopChartsDownloadGameInfo;
  labelKey: string;
  exportTitle: string;
  metric?: string;
  ratioMetric?: string;
  customField?: string;
  hasRatio?: boolean;
}

export const ROBLOX_TOP_CHARTS_DOWNLOAD_GAME_INFO_OPTIONS: IRobloxTopChartsDownloadGameInfoOption[] =
  ROBLOX_TOP_CHARTS_DOWNLOAD_COLUMN_META.map((item) => ({
    key: item.showKey as keyof IRobloxTopChartsDownloadGameInfo,
    labelKey: item.labelKey,
    exportTitle: item.exportTitle,
    metric: item.metric,
    ratioMetric: item.ratioMetric,
    customField: item.customField,
    hasRatio: item.hasRatio,
  }));

export const getDefaultRobloxTopChartsDownloadGameInfo =
  (): IRobloxTopChartsDownloadGameInfo => ({
    pcu_show: false,
    favorite_show: false,
    visit_show: false,
    like_show: false,
    unlike_show: false,
    server_size_show: false,
    supported_features_show: false,
    roblox_genre_show: false,
  });

export const getRobloxTopChartsDownloadMetrics = (): string[] => [
  ...ROBLOX_TOP_CHARTS_METRIC_VALUES,
];

export const getRobloxTopChartsDownloadCustomFields = (
  gameInfo: IRobloxTopChartsDownloadGameInfo,
  baseFields: string[],
): string[] => {
  const fields = [...baseFields];

  ROBLOX_TOP_CHARTS_DOWNLOAD_GAME_INFO_OPTIONS.forEach((item) => {
    if (item.customField && gameInfo[item.key] && !fields.includes(item.customField)) {
      fields.push(item.customField);
    }
  });

  return fields;
};

export { ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC };
